import * as etplayer from "./etplayer";
import * as modAjax from "./modAjax";
import * as modArchive from "./modArchive";
import * as modPlayer from "./modPlayer";

type ListResult = etplayer.Result<ListData>;
type PlayableType = 'song'|'stream';
class ListData {
    items?: ListItem[];
    duration?: number; // in seconds
    hash?: string;
    entities?: string;
}

class ListItem {
    id?: number;
    type?: PlayableType
    title?: string;
    artist?: string;
    duration?: number; // in seconds
}

class ListWidget {
    $listUl: JQuery<HTMLElement>
    type:"songlist"|"playlist"

    constructor($listUl: JQuery<HTMLElement>, type:"songlist"|"playlist") {
        this.$listUl = $listUl;
        this.type = type;
    }

    deleteSelected() {
        var wgt = this;
        $('.selected', this.$listUl).each(function(_idx, item) {
            var selDs = item.dataset;
            var postData = {'id': selDs['id'], 'type': selDs['type'], 'plId': undefined};
            if (wgt.type == 'songlist') {
                if (wgt.$listUl.data('type') == 'playlist') {
                    postData['plId'] = wgt.$listUl.data('id');
                    wgt.showLoadingIndicator();
                    modAjax.post('/archive/playlist/delete/song', postData).then((data) => {
                        wgt.loadData(data, true);
                    });
                }
            }
            else if (wgt.type == 'playlist') {
                wgt.showLoadingIndicator();
                modAjax.post('/player/'+modPlayer.getId()+'/playlist/deleteItem', postData).then((data) => {
                    wgt.loadData(data, true);
                });
            }
        });
    }

    // finds the requested entity in the list
    findRow(type: string|undefined, id: number|undefined): HTMLTableRowElement|undefined {
        var rowIDs = this.$listUl.data('rowIDs') || {};
        return rowIDs[etplayer.entityId(type, id)];
    }

    load(type: string, id: number, deletable: boolean) {
        this.$listUl.data('id', id);
        this.$listUl.data('type', type);
        this.showLoadingIndicator()
        modAjax.request('archive/'+type+'/'+id).then((data) => {
            this.loadData(data, deletable);
        });
    }

    loadData(data: ListResult, deletable=false) {
        if (data && data.result != undefined && data.result.items) {
            var items = data.result.items;
            this.$listUl.empty();
            var cellNames = ['title', 'artist', 'duration'];

            var rowIDs = this.$listUl.data('rowIDs') as {[id: string]: HTMLDivElement};
            if (rowIDs === undefined) {
                rowIDs = {};
                this.$listUl.data('rowIDs', rowIDs);
            }

            for (let i in items) {
                let item = items[i];
                if (item.id == undefined) throw "unexpected: missing entity id";
                if (item.type == undefined) throw "unexpected: missing entity type";

                var $row = $('<div class="listRow clickable" draggable="true">') as JQuery<HTMLDivElement>;
                $row.on('dragstart', dragItem);
                if (deletable===true || this.type == 'playlist') $row.addClass('deletable');

                var cells = [item.title, item.artist, etplayer.formatDuration(item.duration, item.type)];
                for (var j in cells) {
                    var $div = $('<div>');
                    $div.text(cells[j] || "").addClass((cellNames[j])+'Col');
                    //var div = document.createTextNode(cells[j]);
                    $row.append($div);
                }
                $row.attr('data-id', item.id);
                $row.attr('data-type', item.type);
                rowIDs[etplayer.entityId(item.type, item.id)] = $row[0];
                $row.on('click', (ev) => {
                    var toggle = ev.metaKey || ev.ctrlKey;
                    selectionChanged(this.$listUl, $(ev.currentTarget), toggle);
                });
                this.$listUl.append($row);
            }

            $('#'+this.type+'Duration').text(formatListDuration(data.result.duration));

            if (data.result.hash != undefined) {
                this.$listUl.data('_hash', data.result.hash);
            }

            var entities = data.result.entities;
            if (!entities) entities = '';
            $('#'+this.type+'Lists').text(entities);
        }

        var $wrapper = this.$listUl.parent().removeClass("loading");
        $('.loadingIndicator', $wrapper).stop().fadeOut(100);
    }

    // 'play' or 'enqueue' the selected list items
    playSelected(mode: 'play'|'enqueue') {
        if ({'play':0, 'enqueue':0}[mode] === undefined) {
            throw "playSelected: unsupported mode: "+mode;
        }

        // TODO do this in a single request (instead of one per selected item)
        let postData: ListItem[] = [];
        $('.selected', this.$listUl).each(function(_idx, item) {
            let id = item.dataset['id'];
            let type = item.dataset['type'] as PlayableType | undefined;
            if (id == undefined || type == undefined) throw "unexpected: selected item lacks id and/or type";
            postData.push({id: parseInt(id), type: type});
        });

        // call play/enqueue for each item
        var cb = function cb(items: ListItem[], mode: "play"|"enqueue") {
            // TODO this doesn't loop over the whole postData list!
            if (items.length == 0) return;
            playlist.showLoadingIndicator();
            modAjax.post("/player/"+modPlayer.getId()+"/"+mode, items.shift()).then((data) => {
                playlist.loadData(data);
            });

            // everything but the first item will be enqueued
            if (mode == 'play') mode = 'enqueue';
            cb(items, mode);
        };
        cb(postData, mode);
    }

    // scrolls down by 'direction * height'
    scrollPage(direction: number) {
        let scrollTop = this.$listUl.scrollTop();
        let height = this.$listUl.height();
        if (scrollTop == undefined || height == undefined) throw this.type+".scrollPage(): undefined height and/or scrollTop";

        let tgtPos = scrollTop + height * direction; // scroll a whole page
        this.scrollTo(tgtPos);
    }

    scrollTo(pos: number) {
        let scrollTop = this.$listUl.scrollTop();
        let height = this.$listUl.height();
        if (scrollTop == undefined || height == undefined) throw this.type+".scrollTo(): undefined height and/or scrollTop";
        if (Math.abs(scrollTop-pos) <= height+100) {
            // animate scroll if it's not too far
            this.$listUl.stop().animate({scrollTop:pos}, 250);
        }
        else this.$listUl.stop().scrollTop(pos);
    }

    showLoadingIndicator() {
        var $wrapper = this.$listUl.parent();
        $('.loadingIndicator', $wrapper).stop().fadeIn(300);
    }
}

function dragItem(ev: JQuery.DragStartEvent) {
    let dataTransfer = ev.originalEvent?.dataTransfer;
    var data = (ev.target as HTMLElement).dataset;
    if (dataTransfer == null) throw "modList.dragItem: null dataTransfer";
    dataTransfer.setData(etplayer.ERT_MIMETYPE, JSON.stringify([{type: data.type, id: data.id}] as etplayer.DraggedList));
}

export function dropOnSonglist(ev: JQuery.DropEvent) {
    let dataTransfer = ev.originalEvent?.dataTransfer;
    var $songlist = $('#songlist');
    var plId = $songlist.data('id');

    if (dataTransfer == undefined) throw "dropOnSonglist: missing dataTransfer";
    var data: etplayer.DraggedList = JSON.parse(dataTransfer.getData(etplayer.ERT_MIMETYPE));
    if ($songlist.data('type') != 'playlist') throw "can only drop on user playlists!";
    console.log("drop:");
    songlist.showLoadingIndicator();

    modAjax.request("/archive/playlist/add?plId="+plId, JSON.stringify(data), {
        method: 'POST',
        contentType: "application/json",
    }).then((data) => {
        songlist.loadData(data);
    });
}

export function dropOnPlaylist(ev: JQuery.DropEvent) {
    let dataTransfer = ev.originalEvent?.dataTransfer;
    if (dataTransfer == undefined) throw "dropOnPlaylist: missing dataTransfer";

    var data: etplayer.DraggedList = JSON.parse(dataTransfer.getData(etplayer.ERT_MIMETYPE));
    if (data.length != 1) {
        throw "drop data has to be a list of length 1";
    }
    var reqData = data[0];
    playlist.showLoadingIndicator();
    modAjax.post("/player/"+modPlayer.getId()+"/playlist/append", reqData).then((data) => {
        playlist.loadData(data);
    });
}

function formatListDuration(sec: number|undefined): string {
    if (sec == undefined) return "--";
    let rc = [];

    if (sec > 3600) {
        rc.push(Math.floor(sec/3600)+'h');
        sec %= 3600;
    }
    rc.push(Math.floor(sec / 60)+'m');
    rc.push(Math.floor(sec%60)+'s');
    return rc.join(' ')
}

export function selectionChanged($list: JQuery<HTMLElement>, $item: JQuery<HTMLElement>, toggle=false) {
    if (!toggle) {
        $('.selected', $list).removeClass("selected");
    }

    // show/hide the delete button
    var isDeletable = $item.hasClass('deletable');
    if (isDeletable && $item.data('type') == 'folder') {
        // only allow to delete empty userPl folders
        if ($item.siblings('ul').children().length > 0) isDeletable = false;
    }
    $("#"+$list.attr('id')+"DeleteBtn").css('display', isDeletable ? 'inline' : 'none');

    if (!toggle) {
        $item.addClass("selected");

        if ($item.data('type') == "song") {
            modArchive.fetchSongInfo($item.data('id')).then((info) => {
                if (info.pls !== undefined && !$.isEmptyObject(info.pls)) {
                    modArchive.showPlaylists(info.pls);
                }
            });
        }
    }
    else $item.toggleClass("selected");
}

export var songlist = new ListWidget($('#songlist'), 'songlist');
export var playlist = new ListWidget($('#playlist'), 'playlist');
